import React from 'react';
import { PriceDisplay } from '../utils/currency';
import { trackAddToCart } from './MetaPixel';
export const Checkout = () => {
  const handleBuyClick = (e: React.MouseEvent) => {
    trackAddToCart();
  };
  return <section id="checkout" className="py-16 px-4 sm:px-6 md:px-8 max-w-7xl mx-auto bg-[#F8F2EA]" data-id="element-25">
      <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-xl overflow-hidden" data-id="element-26">
        <div className="flex flex-col md:flex-row" data-id="element-27">
          <div className="md:w-1/2 p-8 flex flex-col justify-center" data-id="element-28">
            <h2 className="font-serif text-2xl sm:text-3xl font-bold text-[#0C1B2A] mb-6" data-id="element-29">
              Transforma tu energía hoy mismo
            </h2>
            <div className="mb-6" data-id="element-30">
              <h3 className="font-serif text-xl font-semibold text-[#0C1B2A] mb-4 flex items-center" data-id="element-31">
                <svg className="w-5 h-5 text-[#D4AF37] mr-2" fill="currentColor" viewBox="0 0 20 20" data-id="element-32">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-33" />
                </svg>
                Lo que obtienes:
              </h3>
              <ul className="space-y-2 mb-4" data-id="element-34">
                <li className="flex items-start" data-id="element-35">
                  <svg className="w-5 h-5 text-[#D4AF37] mr-2 mt-0.5" fill="currentColor" viewBox="0 0 20 20" data-id="element-36">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-37" />
                  </svg>
                  <span data-id="element-38">Guía Contra el Mal de Ojo (PDF)</span>
                </li>
                <li className="flex items-start" data-id="element-39">
                  <svg className="w-5 h-5 text-[#D4AF37] mr-2 mt-0.5" fill="currentColor" viewBox="0 0 20 20" data-id="element-40">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-41" />
                  </svg>
                  <span data-id="element-42">Plan de 7 días con rituales diarios</span>
                </li>
                <li className="flex items-start" data-id="element-43">
                  <svg className="w-5 h-5 text-[#D4AF37] mr-2 mt-0.5" fill="currentColor" viewBox="0 0 20 20" data-id="element-44">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-45" />
                  </svg>
                  <span data-id="element-46">Oraciones de protección familiar</span>
                </li>
              </ul>
              <h3 className="font-serif text-xl font-semibold text-[#0C1B2A] mb-4 flex items-center" data-id="element-47">
                <svg className="w-5 h-5 text-[#D4AF37] mr-2" fill="currentColor" viewBox="0 0 20 20" data-id="element-48">
                  <path fillRule="evenodd" d="M5 5a3 3 0 015-2.236A3 3 0 0114.83 6H16a2 2 0 110 4h-5V9a1 1 0 10-2 0v1H4a2 2 0 110-4h1.17C5.06 5.687 5 5.35 5 5zm4 1V5a1 1 0 10-1 1h1zm3 0a1 1 0 10-1-1v1h1z" clipRule="evenodd" data-id="element-49" />
                  <path d="M9 11H3v5a2 2 0 002 2h4v-7zM11 18h4a2 2 0 002-2v-5h-6v7z" data-id="element-50" />
                </svg>
                5 Bonos especiales:
              </h3>
              <ul className="space-y-2" data-id="element-51">
                <li className="flex items-start" data-id="element-52">
                  <svg className="w-5 h-5 text-[#D4AF37] mr-2 mt-0.5" fill="currentColor" viewBox="0 0 20 20" data-id="element-53">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-54" />
                  </svg>
                  <span data-id="element-55">Kit de Oraciones y Decretos Protectores</span>
                </li>
                <li className="flex items-start" data-id="element-56">
                  <svg className="w-5 h-5 text-[#D4AF37] mr-2 mt-0.5" fill="currentColor" viewBox="0 0 20 20" data-id="element-57">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-58" />
                  </svg>
                  <span data-id="element-59">Calendario de Rituales Energéticos 2025</span>
                </li>
                <li className="flex items-start" data-id="element-60">
                  <svg className="w-5 h-5 text-[#D4AF37] mr-2 mt-0.5" fill="currentColor" viewBox="0 0 20 20" data-id="element-61">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-62" />
                  </svg>
                  <span data-id="element-63">Amuletos de Protección Ancestrales</span>
                </li>
                <li className="flex items-start" data-id="element-64">
                  <svg className="w-5 h-5 text-[#D4AF37] mr-2 mt-0.5" fill="currentColor" viewBox="0 0 20 20" data-id="element-65">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-66" />
                  </svg>
                  <span data-id="element-67">Guía de limpiezas energética Exprés</span>
                </li>
                <li className="flex items-start" data-id="element-68">
                  <svg className="w-5 h-5 text-[#D4AF37] mr-2 mt-0.5" fill="currentColor" viewBox="0 0 20 20" data-id="element-69">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-70" />
                  </svg>
                  <span data-id="element-71">Atlas de Símbolos de Protección Universal</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="md:w-1/2 bg-[#0C1B2A] p-8 text-white" data-id="element-72">
            <div className="flex items-center justify-between mb-6" data-id="element-73">
              <h3 className="font-serif text-2xl font-bold" data-id="element-74">Precio único</h3>
              <div className="text-right" data-id="element-75">
                <span className="block text-3xl font-bold" data-id="element-76">$11.99</span>
                <span className="text-sm opacity-75 line-through" data-id="element-77">
                  Antes $45.99
                </span>
                <span className="text-sm text-green-400 block" data-id="element-78">
                  ¡Ahorras $34!
                </span>
              </div>
            </div>
            <div className="bg-white bg-opacity-10 p-4 rounded-lg mb-6" data-id="element-79">
              <div className="flex items-center mb-4" data-id="element-80">
                <svg className="w-5 h-5 text-[#D4AF37] mr-2" fill="currentColor" viewBox="0 0 20 20" data-id="element-81">
                  <path fillRule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-82" />
                </svg>
                <span className="font-semibold" data-id="element-83">Garantía de 7 días</span>
              </div>
              <p className="text-sm opacity-90" data-id="element-84">
                Si no sientes un cambio real en 7 días, te devolvemos tu dinero.
                Sin preguntas.
              </p>
            </div>
            <a href="https://pay.hotmart.com/Y101890168S?checkoutMode=10" className="btn-purchase block w-full bg-[#D4AF37] hover:bg-[#C5A028] text-[#0C1B2A] font-bold py-4 px-6 rounded-lg text-lg shadow-lg transition-colors duration-300 mb-4 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#D4AF37] focus:ring-offset-[#0C1B2A] text-center" aria-label="Comprar ahora por once dólares con noventa y nueve centavos" onClick={handleBuyClick} data-id="element-85">
              Comprar ahora — $11.99
            </a>
            <div className="text-center mb-4" data-id="element-86">
              <PriceDisplay data-id="element-87" />
            </div>
            <div className="flex justify-center items-center text-sm opacity-75 space-x-3" data-id="element-88">
              <span className="flex items-center" data-id="element-89">
                <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20" data-id="element-90">
                  <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" data-id="element-91" />
                </svg>
                Pago seguro
              </span>
              <span className="flex items-center" data-id="element-92">
                <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20" data-id="element-93">
                  <path d="M10 3.5a1.5 1.5 0 013 0V4a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-.5a1.5 1.5 0 000 3h.5a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-.5a1.5 1.5 0 00-3 0v.5a1 1 0 01-1 1H6a1 1 0 01-1-1v-3a1 1 0 00-1-1h-.5a1.5 1.5 0 010-3H4a1 1 0 001-1V6a1 1 0 011-1h3a1 1 0 001-1v-.5z" data-id="element-94" />
                </svg>
                Descarga inmediata
              </span>
              <span className="flex items-center" data-id="element-95">
                <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20" data-id="element-96">
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" data-id="element-97" />
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" data-id="element-98" />
                </svg>
                Soporte por email
              </span>
            </div>
          </div>
        </div>
        <div className="px-8 py-4 text-xs text-center text-gray-500" data-id="element-99">
          Al comprar, aceptas nuestros{' '}
          <a href="/terminos" className="underline" data-id="element-100">
            Términos y Condiciones
          </a>{' '}
          y{' '}
          <a href="/privacidad" className="underline" data-id="element-101">
            Política de Privacidad
          </a>
        </div>
      </div>
    </section>;
};